// Use Firebase compat mode for react-redux-firebase v3 compatibility
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import 'firebase/compat/database'

// Modular auth API — shares the same underlying auth instance with compat
import {getAuth, connectAuthEmulator} from 'firebase/auth'

import env from '../env'

const config = {
  apiKey: env.firebaseApiKey,
  authDomain: env.authDomain,
  databaseURL: env.firestoreURL,
  projectId: env.firebaseProjectId,
  storageBucket: env.firebaseStorageBucket,
  messagingSenderId: env.firebaseMessageSenderId
}

// Initialize Firebase app
firebase.initializeApp(config)

// Get the modular auth instance and connect to the emulator BEFORE any other
// auth initialization. The compat firebase.auth() and modular getAuth() share
// the same underlying AuthImpl; connecting the emulator first ensures the popup
// redirect resolver picks up the emulator URL when compat auth initializes.
export const modularAuth = getAuth(firebase.app())

if (window.location.hostname === 'localhost') {
  connectAuthEmulator(modularAuth, 'http://localhost:9099', {
    disableWarnings: true,
  })
}

// Initialize compat services (used by react-redux-firebase).
// auth is initialized AFTER connectAuthEmulator so the popup resolver inherits
// the emulator configuration.
export const db = firebase.firestore()
export const auth = firebase.auth()
export const functions = firebase.functions()
export const database = firebase.database()

if (window.location.hostname === 'localhost') {
  try {
    db.useEmulator('localhost', 8080)
    functions.useEmulator('localhost', 5001)
  } catch (error) {
    console.log('Emulator already connected:', error.message)
  }
}

console.log('Firebase compat + modular auth initialized')

// Export the firebase object for react-redux-firebase compatibility
export default firebase
